<opac-swiper
  [configuration]="swiperConfig"
  (slideChange)="onActiveIndexChange($event)"
  [gradient]="false"
>
  <opac-swiper-item *ngFor="let banner of banners">
    <div class="banner-swiper__item" [class.clickable]="banner.url || banner.clickable" (click)="bannerButtonClick(banner)">
      <div class="banner-swiper__item__img" [ngStyle]="{'background-image': 'url(\'' + banner.image + '\')'}"></div>
      <div class="details-wrapper" *ngIf="banner.showInfo" [class.align-right]="banner.align === 'R'">
        <div class="banner-swiper__item__details">
          <div class="details__content">
            <div class="details__content__text" tabindex="-1">
              <h2 class="text__title" *ngIf="banner.title">{{ banner.title }}</h2>
              <p class="text__info" *ngIf="banner.content">{{ banner.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </opac-swiper-item>
</opac-swiper>
